
export default function (props) {
  const { tabs = [], setTab = () => {} } = props;
  return (
    <div>
      {tabs.length > 0 && (
        <div className="border-b">
          <div>
            <nav className="-mb-px flex" aria-label="Tabs">
              {tabs.map((tab, index) => {
                const isActive = tab.active === true;
                const baseClasses =
                  'relative flex w-48 justify-center bg-white py-5 text-center text-sm';
                const activeClasses =
                  'border-b-2 border-blue-500 text-blue-700';
                const inactiveClasses = 'border-b';

                return (
                  <button
                    key={tab.name + index}
                    className={`${baseClasses} ${
                      isActive ? activeClasses : inactiveClasses
                    }`}
                    onClick={() => {
                      setTab(tab);
                    }}
                  >
                    {tab.name}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>
      )}
      {props.children}
    </div>
  );
}
